const routes = [
    {
        path: '/',
        name: 'student',
        component: () => import('@/views/student/index.vue'),
        meta: {title: "学生端主页",role: "学生"},
        children: [
            {
                path: '/home',
                name: 'home',
                component: () => import('@/views/student/home.vue'),
                meta: {title: "主页",role: "学生"}
            },
            {
                path: '/studyway',
                name: 'studyway',
                component: () => import('@/views/student/studyway/studyway.vue'),
                meta: {title: "学习之旅",role: "学生"}
            },
            {
                path: '/books',
                name: 'books',
                component: () => import('@/views/student/studyway/books.vue'),
                meta: {title: "书籍页",role: "学生"}
            },
            {
                path: '/units',
                name: 'units',
                component: () => import('@/views/student/studyway/units.vue'),
                meta: {title: "单元页",role: "学生"}
            },
            {
                path: '/wordcontent',
                name: 'wordcontent',
                component: () => import('@/views/student/studentcontent/wordcontent.vue'),
                meta: {title: "单元页",role: "学生"}
            },
            {
                path: '/study',
                name: 'study',
                component: () => import('@/views/student/studentcontent/study.vue'),
                meta: {title: "单元页",role: "学生"}
            },
            // 学习之旅测试页
            {
                path: '/testpage',
                name: 'testpage',
                component: () => import('@/views/student/studentcontent/testpage.vue'),
                meta: {title: "单元页",role: "学生"}
            },
            {
                path: '/secharts',
                name: 'secharts',
                component: () => import('@/views/student/echarts/echarts.vue'),
                meta: {title: "学情分析",role: "学生"}
            },
            {
                path: '/afterClass',
                name: 'afterClass',
                component: () => import('@/views/student/afterClass/afterClass.vue'),
                meta: {title: "课后训练",role: "学生"}
            },

            {
                path: '/afterBooks',
                name: 'afterBooks',
                component: () => import('@/views/student/afterClass/books.vue'),
                meta: {title: "书籍页",role: "学生"}
            },
            {
                path: '/afterUnits',
                name: 'afterUnits',
                component: () => import('@/views/student/afterClass/units.vue'),
                meta: {title: "单元页",role: "学生"}
            },
            {
                path: '/afterWordcontent',
                name: 'afterWordcontent',
                component: () => import('@/views/student/afterClass/wordcontent.vue'),
                meta: {title: "单元页",role: "学生"}
            },
            {
                path: '/afterStudy',
                name: 'afterStudy',
                component: () => import('@/views/student/afterClass/study.vue'),
                meta: {title: "单元页",role: "学生"}
            },
            // 学习之旅测试页
            {
                path: '/afterTestpage',
                name: 'afterTestpage',
                component: () => import('@/views/student/afterClass/testpage.vue'),
                meta: {title: "单元页",role: "学生"}
            },
            {
                path: '/afterReview',
                name: 'afterReview',
                component: () => import('@/views/student/afterReview/afterReview.vue'),
                meta: {title: "课后复习",role: "学生"}
            },

            {
                path: '/afterReviewBooks',
                name: 'afterReviewBooks',
                component: () => import('@/views/student/afterReview/books.vue'),
                meta: {title: "书籍页",role: "学生"}
            },
            {
                path: '/afterReviewUnits',
                name: 'afterReviewUnits',
                component: () => import('@/views/student/afterReview/units.vue'),
                meta: {title: "单元页",role: "学生"}
            },
            {
                path: '/afterReviewWordcontent',
                name: 'afterReviewWordcontent',
                component: () => import('@/views/student/afterReview/wordcontent.vue'),
                meta: {title: "单元页",role: "学生"}
            },
            {
                path: '/afterReviewStudy',
                name: 'afterReviewStudy',
                component: () => import('@/views/student/afterReview/study.vue'),
                meta: {title: "单元页",role: "学生"}
            },
            // 学习之旅测试页
            {
                path: '/afterReviewTestpage',
                name: 'afterReviewTestpage',
                component: () => import('@/views/student/afterReview/testpage.vue'),
                meta: {title: "单元页",role: "学生"}
            },
            {
                path: '/wordbook',
                name: 'wordbook',
                component: () => import('@/views/student/wordbook/wordbook.vue'),
                meta: {title: "单词本",role: "学生"},
                children: [
                    {
                        path: 'question',
                        name: 'question',
                        component: () => import('@/views/student/wordbook/question.vue'),
                        meta: {title: '错题本',role: "学生"}
                    },
                    {
                        path: 'collection',
                        name: 'collection',
                        component: () => import('@/views/student/wordbook/collection.vue'),
                        meta: {title: '我的收藏',role: "学生"}
                    },
                    {
                        path: 'mastered',
                        name: 'mastered',
                        component: () => import('@/views/student/wordbook/mastered.vue'),
                        meta: {title: 'AI智能',role: "学生"}
                    },
                    {
                        path: 'wordreading',
                        name: 'wordreading',
                        component: () => import('@/views/student/wordbook/wordreading.vue'),
                        meta: {title: '词阅工坊',role: "学生"}
                    }
                ]
            },
            {
                path: '/wrongquestion',
                name: 'wrongquestion',
                component: () => import('@/views/student/wordbook/wrongquestion.vue'),
                meta: {title: "错题库",role: "学生"}
            },
            {
                path: '/personalCenter',
                name: 'personalCenter',
                component: () => import('@/views/student/personal/personalCenter.vue'),
                meta: {title: "个人中心",role: "学生"},
                children: [
                    {
                        path: 'coins',
                        name: 'coins',
                        meta: {title: "我的金币",role: "学生"},
                        component: () => import('@/views/student/personal/coins.vue'),
                    },
                    {
                        path: 'pretest',
                        name: 'pretest',
                        meta: {title: "单词前测",role: "学生"},
                        component: () => import('@/views/student/personal/pretest.vue'),
                    },
                    {
                        path: 'test',
                        name: 'test',
                        meta: {title: "我的金币",role: "学生"},
                        component: () => import('@/views/student/personal/test.vue'),
                    },
                    {
                        path: 'questionnaire',
                        name: 'questionnaire',
                        meta: {title: "我的问卷",role: "学生"},
                        component: () => import('@/views/student/personal/questionnaire.vue'),
                    },
                    {
                        path: 'review',
                        name: 'review',
                        meta: {title: "课后复习",role: "学生"},
                        component: () => import('@/views/student/personal/review.vue'),
                    },
                    {
                        path: 'reading',
                        name: 'reading',
                        meta: {title: "课后阅读",role: "学生"},
                        component: () => import('@/views/student/personal/reading.vue'),
                    },
                    {
                        path: 'ranking',
                        name: 'ranking',
                        meta: {title: "金币排行榜",role: "学生"},
                        component: () => import('@/views/student/personal/ranking.vue'),
                    },
                    {
                        path: 'studyAchievements',
                        name: 'studyAchievements',
                        meta: {title: "学习成果",role: "学生"},
                        component: () => import('@/views/student/personal/studyAchievements.vue'),
                    },
                    // {
                    //   path: '/class/classStudent',
                    //   name: 'classStudent',
                    //   meta: { title: "班级学生" },
                    //   component: () => import('@/views/teacher/class/classStudent.vue'),
                    // },
                ],
            },
            {
                path: '/setUpPage',
                name: 'setUpPage',
                meta: {title: "设置",role: "学生"},
                component: () => import('@/views/student/setUpPage/setUpPage.vue'),
                children: [
                    {
                        path: 'information',
                        name: 'information',
                        meta: {title: "基本资料",role: "学生"},
                        component: () => import('@/views/student/setUpPage/information.vue')
                    },
                    {
                        path: 'commonproblem',
                        name: 'commonproblem',
                        meta: {title: "常见问题",role: "学生"},
                        component: () => import('@/views/student/setUpPage/commonproblem.vue')
                    },
                    {
                        path: 'opinion',
                        name: 'opinion',
                        meta: {title: "意见反馈",role: "学生"},
                        component: () => import('@/views/student/setUpPage/opinion.vue')
                    },
                ]
            },
            // 测试
            {
                path: '/totaltest',
                name: 'totaltest',
                component: () => import('@/views/student/test/totaltest.vue'),
                meta: {title: "测试",role: "学生"}
            },

        ],
    }
]
export default routes
